module.exports = "/_next/static/images/app-store-2d828abb049223dd4780db646aa0a4d0.png";